module.exports = __webpack_public_path__ + "static/z_tall_quantum-b7f75a2b7add8f51299362e1aa43f573.jpg";